import { render, staticRenderFns } from "./SimpleTestComponent.vue?vue&type=template&id=56a34c41"
import script from "./SimpleTestComponent.vue?vue&type=script&lang=js"
export * from "./SimpleTestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports